// extracted by mini-css-extract-plugin
module.exports = {"Woman":"styles_Woman__36_1w","fadeIn":"styles_fadeIn__2X6NY"};